import useAccountStore from '@/account/accountStore'
import type { Account } from '@/common/types'

export function usePrimaryAccount(): Account | null {
    return useAccountStore((s) => s.getPrimaryAccount())
}
